import { getAddPricingDetailAction } from "./action";



const initialState = {
    getPricingPartnerDetail: {},
    error: "",
    saveAddPricingPartner: null,
  };

const addPartnerPricingDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case getAddPricingDetailAction.ADD_PARTNER_PRICING_DETAILS_SUCCESS:
      return {
        ...state,
        getPricingPartnerDetail: action.payload,
      }

    case getAddPricingDetailAction.GET_PRICING_DETAIL_SUCCESS:
      return {
        getPricingPartnerDetail: action.payload,
      }

    default:
        return state;
    }
}

export default addPartnerPricingDetailsReducer;